// extracted by mini-css-extract-plugin
export var image = "_il-0";